import axiosInstance from 'Api';

const getMelderCounts = () => {
    return axiosInstance.get("reports/count");
};

const getSubstitutorCounts = () => {
    return axiosInstance.get("substitutor/count");
};
const absentData = (schoolId, communityId) => {
    return axiosInstance.get(`absents-list?iSchoolId=${schoolId}&iCommunityId=${communityId}`
    );
};


const CommonService = {
    getMelderCounts,
    getSubstitutorCounts,
    absentData
};
export default CommonService;